module.exports = __webpack_public_path__ + "static/media/c6.025968ea.jpg";